import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductMatrixGroup } from '../models/product-matrix';
import { Berufsgruppe } from '../models/berufsgruppe';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProductMatrixService {
  private readonly api = inject(ApiService);
  private readonly auth = inject(AuthService);

  getGroups(): Observable<ProductMatrixGroup[]> {
    return this.api.get<ProductMatrixGroup[]>('productMatrixRouter/getProductMatrix');
  }

  getBerufsGruppe(): Observable<Berufsgruppe> {
    return this.api.get<Berufsgruppe>(`productMatrixRouter/getBerufsgruppeUserId/${this.auth.user._id}`);
  }

  saveGroup(group: ProductMatrixGroup): Observable<ProductMatrixGroup> {
    return this.api.post<ProductMatrixGroup>('productMatrixRouter/saveProductMatrix', {
      group,
      _id: this.auth.user._id,
    });
  }

  deleteGroup(groupId: string): Observable<void> {
    return this.api.delete<void>(`productMatrixRouter/deleteGroup/${groupId}`);
  }

  deleteBerufsGruppe(groupId: string, berufGruppeId: string): Observable<void> {
    return this.api.delete<void>(
      `productMatrixRouter/deleteHistoryBerufGruppe/${groupId}/berufGruppen/${berufGruppeId}`
    );
  }

  updateProductMatrixImmediately(): Observable<{ message: string }> {
    return this.api.post<{ message: string }>('productMatrixRouter/immediateUpdateProductMatrixGroups');
  }

  scheduleUpdate(groupId: string, date: Date): Observable<void> {
    return this.api.post<void>('productMatrixRouter/scheduleUpdate', {
      groupId,
      updateDate: date,
      _id: this.auth.user._id,
    });
  }

  uploadProductMatrixGroups(file: File, selectedDate: Date): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('_id', this.auth.user._id);
    formData.append('selectedDate', selectedDate.toISOString());

    return this.api.postText('productMatrixRouter/uploadProductMatrixGroups', formData);
  }
}
